import { string } from 'yup';

const required = () => string().required('Required');

export { required };
